<template>
  <!-- class="h100" -->
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
// 主内容
export default {
  name: "Main",
  data() {
    return {};
  },
  components: {}
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/home/Main.vue